<template>
  <div>
    <!-- MENSAJES DE CONFIRMACIÓN ---->
    <mensajeSistema></mensajeSistema>

    <v-card class="mb-4">
      <v-form ref="formMiColegio" lazy-validation>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="12" md="12" class="pb-0">
              <v-alert dense border="left" class="text-center" color="primary" dark>
                <h3>INFORMACIÓN DEL {{ $t("titulo.colegioArticulo") }}</h3>
              </v-alert>
            </v-col>

            <v-col cols="12" sm="12" md="9">
              <v-row>
                <v-col cols="12" sm="6" md="4" lg="4">
                  <textfieldComp textLabel="Nombre" v-model="editedItem.nombre_colegio" readonly icon="fa-school" />
                  <!-- <v-text-field
                    label="Nombre"
                    v-model="editedItem.nombre_colegio"
                    readonly
                    prepend-icon="fa-school"
                  ></v-text-field> -->
                </v-col>

                <v-col cols="12" sm="6" md="4" lg="4">
                  <textfieldComp textLabel="RUC" v-model="editedItem.ruc_colegio" readonly icon="fa-id-badge" />
                </v-col>

                <v-col cols="12" sm="6" md="4" lg="4">
                  <textfieldComp textLabel="Fecha de constitución" v-model="editedItem.fec_constitucion" type="date"
                    readonly icon="fa-calendar-alt" />
                </v-col>

                <v-col cols="12" sm="6" md="4" lg="4">
                  <textfieldComp textLabel="Correo electrónico" v-model="editedItem.correo_colegio"
                    :rules="validationRules.validateCorreo" icon="fa-envelope" />
                </v-col>

                <v-col cols="12" sm="5" md="4" lg="3">
                  <textfieldComp textLabel="Teléfono" type="tel" v-model="editedItem.telf_colegio" icon="fa-phone-alt"
                    :rules="validationRules.validatePhone" placeholder="+0100000" v-mask="'+###################'" />
                </v-col>

                <v-col cols="12" sm="5" md="3">
                  <textfieldComp textLabel="Sitio web" v-mask="'www.XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX'"
                    v-model="editedItem.web_colegio" icon="fa-globe" placeholder="www.example.com" />
                </v-col>

                <v-col cols="12" sm="2" md="2">
                  <textfieldComp textLabel="Extensión" placeholder=".com" v-mask="'.aaa.aaaaa'"
                    v-model="editedItem.extension" />
                </v-col>
              </v-row>
            </v-col>

            <!-- AVATAR  -->
            <v-col cols="12" sm="12" md="3" xs="12" class="d-flex justify-center order-first order-md-0">
              <v-avatar width="140" height="170" class="avatar_fondo_add_img pa-1" @click="pickLogo">
                <v-icon color="grey lighten-2" class="fondo_add_img" size="60" v-if="!editedItem.logo_colegio && !previewImgLogo">far fa-image</v-icon>          
                    <v-img
                      v-if="editedItem.logo_colegio && !previewImgLogo"
                      :src="`${rutaSpace}${editedItem.logo_colegio}`"
                      aspect-ratio="1"
                      dark
                      contain
                      class="fondo_add_img"
                      > 
                      <!-- ?nocache=${new Date().getTime()} -->
                      <template v-slot:placeholder>
                            <v-layout
                              fill-height
                              align-center
                              justify-center
                              ma-0
                            >
                        <v-progress-circular indeterminate color="grey lighten-1"></v-progress-circular>
                      </v-layout>
                    </template>
                  </v-img>


                <v-img
                  v-if="previewImgLogo"
                  :src="previewImgLogo"
                  contain
                  aspect-ratio="1"
                  class="fondo_add_img"
                />                

                <input
                  type="file"
                  style="display: none"
                  ref="imageCol"
                  accept=".jpg, .png, .gif"
                  @change="onFileLogo"
                />
              </v-avatar>
            </v-col>

            <!-- PAÍS  -->
            <v-col cols="12" sm="6" md="4" lg="3">
              <textfieldComp v-model="editedItem.nombre_pais" textLabel="País" icon="fa-flag" readonly />
            </v-col>

            <!-- UBICACIÓN 1  -->
            <v-col cols="12" sm="6" md="4" lg="3">
              <AutocompleteComp :items="ubicacion1" v-model="editedItem.id_ubicacion1"
                @change="getUbicacion2Id(editedItem.id_ubicacion1)" item-text="nombre_ubicacion1" item-value="id"
                :textLabel="$t('ubicacion.ubicacion1')" :rules="validationRules.validateCampo" icon="fa-flag" />
            </v-col>

            <!-- UBICACIÓN 2  -->
            <v-col cols="12" sm="6" md="4" lg="3">
              <AutocompleteComp :items="ubicacion2" v-model="editedItem.id_ubicacion2"
                @change="getUbicacion3Id(editedItem.id_ubicacion2)" item-text="nombre_ubicacion2" item-value="id"
                :textLabel="$t('ubicacion.ubicacion2')" :rules="validationRules.validateCampo" icon="fa-flag" />
            </v-col>

            <!-- UBICACIÓN 3  -->
            <v-col cols="12" sm="6" md="4" lg="3">
              <AutocompleteComp :items="ubicacion3" v-model="editedItem.id_ubicacion3" item-text="nombre_ubicacion3"
                item-value="id" :textLabel="$t('ubicacion.ubicacion3')" :rules="validationRules.validateCampo"
                @change="district(editedItem.id_ubicacion3)" icon="fa-flag" />
            </v-col>

            <!-- DIRECCIÓN DEL COLEGIO  -->
            <v-col cols="12" sm="6" md="4" lg="4">
              <textfieldComp textLabel="Dirección del colegio" v-model="editedItem.direc_colegio"
                :rules="validationRules.validateDirecciondelColegio" icon="fa-route"
                @keypress="validar_direccion($event)" />
            </v-col>

            <!-- DRE -->
            <v-col cols="12" sm="4" md="4">
              <textfieldComp textLabel="Dirección Regional de Educación" v-model="editedItem.dre" icon="fa-flag"
                :rules="validationRules.validateCampo" :readonly="editedItem.dre != ''" />
            </v-col>

            <!-- UGEL -->
            <v-col cols="12" sm="4" md="4">
              <textfieldComp textLabel="Unidad de Gestión Educativa Local" v-model="editedItem.ugel" icon="fa-flag"
                :rules="validationRules.validateCampo" :readonly="editedItem.ugel != ''" />
            </v-col>

            <!-- CAMBIO NOTAS  -->
            <template>
              <v-col cols="12" sm="6" md="4" lg="4">
                <span>Habilitar cambio de notas</span>
                <div @click="dialog = true">
                  <v-radio-group :value="getRadioValue()" @change="(value) => {
                    editedItem.cambio_notas = value === 'true';
                  }
                    " row :rules="validationRules.validateCampo" disabled>
                    <v-radio label="NO" value="false"></v-radio>
                    <v-radio label="SÍ" value="true"></v-radio>
                  </v-radio-group>
                </div>
              </v-col>

              <v-dialog v-model="dialog" max-width="300px">
                <v-alert density="compact" type="warning" title="Alert title" class="mb-0">
                  Si desea modificar la opción "Habilitar cambio de notas" , por favor comuníquese con el Manager.
                </v-alert>
              </v-dialog>

            </template>

            <!-- RESOLUCIÓN  -->
            <v-col cols="12" sm="6" md="4" lg="4">
              <textfieldComp textLabel="Resolución" v-model="editedItem.resolucion_colegio" readonly icon="fa-user" />
            </v-col>

            <!-- ESLOGAN  -->
            <v-col cols="12" sm="6" md="4" lg="4">
              <textfieldComp textLabel="Eslogan" v-model="editedItem.slogan_colegio" :rules="validationRules.max150"
                icon="fa-font" />
            </v-col>

            <!-- RESPONSABLE DEL COLEGIO  -->
            <v-col cols="12" sm="12" md="12">
              <v-alert dense border="left" class="text-center" color="primary" dark>
                <h3>RESPONSABLE DEL {{ $t("titulo.colegioArticulo") }}</h3>
              </v-alert>
            </v-col>

            <!-- NOMBRE COMPLETO  -->
            <v-col cols="12" sm="6" md="4" lg="4">
              <textfieldComp textLabel="Nombre completo" type="text" v-model="editedItem.responsable_nombre"
                :rules="validationRules.validateName" icon="fa-user" />
            </v-col>

            <!-- NÚMERO  -->
            <v-col cols="12" sm="6" md="4" lg="4">
              <textfieldComp textLabel="Teléfono" type="number" v-model="editedItem.responsable_telf"
                :rules="validationRules.validateMovilphone" icon="fa-phone-alt" />
            </v-col>

            <!-- CORREO ELECTRONICO  -->
            <v-col cols="12" sm="6" md="4" lg="">
              <textfieldComp textLabel="Correo electrónico" type="email" v-model="editedItem.responsable_correo"
                :rules="validationRules.validateCorreo" icon="fa-envelope" />
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <TableButtonComp textButton="Guardar cambios" iconBut="fas fa-save" @click="saveItem()"
            v-if="componenteEvento.editar_submodulo" normalButton />
        </v-card-actions>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import axios, { API_URL, BUCKET_ORIGIN_SPACE } from "../../helpers/axios";
import AutocompleteComp from "../../components/ComponentsEst/AutocompleteComp.vue";
import textfieldComp from "../../components/ComponentsEst/textfieldComp.vue";
import TableButtonComp from "../../components/ComponentsEst/TableButtonComp.vue";

import { validationRules } from "../../helpers/validatorHelpers.js";
import { mapMutations, mapGetters, mapActions } from "vuex";

export default {
  components: {
    AutocompleteComp,
    textfieldComp,
    TableButtonComp,
  },

  data: () => ({
    //Mensaje al Intentar cambiar la nota
    dialog: false,

    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    paramComponente: { id_submodulo: 6, id_modulo: 6 }, //sud_modulo y modulo

    datoLogin: sessionStorage, // variables de sesion del usuario
    test: false,
    ////////////////////////////////////////////////////////

    //validaciones de formulario

    //----------paises--------
    pais: [],

    //------- UBICACIONES -----------
    ubicacion1: [],
    ubicacion2: [],
    ubicacion3: [],

    imagenSelecionada: null,

    editedItem: {
      id: 0,
      id_ubicacion1: null,
      id_ubicacion2: null,
      id_ubicacion3: null,
      ruc_colegio: "",
      resolucion_colegio: "",
      nombre_colegio: "",
      logo_colegio: "",
      web_colegio: "",
      correo_colegio: "",
      fec_constitucion: "",
      responsable_nombre: "",
      responsable_telf: "",
      responsable_correo: "",
      direc_colegio: "",
      telf_colegio: "",
      estado_colegio: 1,
      id_usuario: 0,
      es_sucursal: 0,
      parent_id_colegio: null,
    },

    ///////////////////// LOGO COLEGIO  ///////////////////////////////
    // Logo Colegio imagen
    previewImgLogo: "",
    imageSaveLogo: "",
    // dre y ugel
    dre: {},
    ugel: {},

    rutaServer: API_URL,
    rutaSpace: BUCKET_ORIGIN_SPACE
    //rutaServer: 'http://localhost:5000/',
  }),

  mounted() {
    this.getColegio();
    this.getPais();
  },

  created() {
    this.actualizarParamentro();
  },

  computed: {
    validationRules() {
      return validationRules;
    },
    ...mapGetters("login", ["componenteEvento"]),
  },

  //metodos
  methods: {
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    //----- Validar accesos por perfil ------------
    ...mapActions("login", ["parametroComponente"]),

    actualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },

    getRadioValue() {
      if (
        this.editedItem.cambio_notas === null ||
        this.editedItem.cambio_notas === false
      ) {
        return "false";
      } else if (this.editedItem.cambio_notas === true) {
        return "true";
      }
    },

    //  ------- MENSAJE DE SISTEMA  --------
    ...mapMutations("mensajeSis", ["setEnviarMens"]),
    ////////////////////////////////////////////////////////

    //-----------obtener paises----------------------------
    async getPais() {
      try {
        let response = await axios.get(
          "/mantenimiento/paises/paisesConfigurados"
        );
        this.pais = response.data;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        //console.log(error);
      }
    },

    validarTelefono(e) {
      //console.log(e)
      this.$options.filters.telefono(e);
    },

    /* DRE Y UGEL */
    clear_dre_ugel() {
      this.editedItem.id_dre = "";
      this.editedItem.dre = " ";
      this.editedItem.id_ugel = "";
      this.editedItem.ugel = " ";
    },

    async getDrebyProvince(id) {
      await axios.get(`/manager/dre/province/${id}`).then(({ data }) => {
        if (data) {
          this.dre = data;
          if (!data.id_distrito) {
            this.editedItem.dre = data.description;
            this.editedItem.id_dre = data.id;
          }
        }
      });
    },

    // obtner DRE por id distrito
    async getDrebyDistrict(id) {
      await axios.get(`/manager/dre/district/${id}`).then(({ data }) => {
        if (data) {
          if (data.id_distrito && this.dre.id_distrito) {
            this.editedItem.dre = data.description;
            this.editedItem.id_dre = data.id;
          }
        }
      });
    },

    async getUgelbyProvince(id) {
      await axios.get(`/manager/ugel/province/${id}`).then(({ data }) => {
        if (data) {
          this.ugel = data;
          if (!data.id_distrito) {
            this.editedItem.id_ugel = data.id;
            this.editedItem.ugel = data.description;
          }
        }
      });
    },

    async getUgelbyDistrict(id) {
      await axios.get(`/manager/ugel/district/${id}`).then(({ data }) => {
        if (data) {
          if (data.id_distrito && this.ugel.id_distrito) {
            this.editedItem.id_ugel = data.id;
            this.editedItem.ugel = data.description;
          }
        }
      });
    },

    async getUgelDreProvince(id) {
      await this.getDrebyProvince(id);
      await this.getUgelbyProvince(id);
    },

    async getUgelDreDistrito(id) {
      await this.getDrebyDistrict(id);
      await this.getUgelbyDistrict(id); //
    },

    async district(id) {
      if (this.dre.id_distrito && this.ugel.id_distrito) {
        await this.getUgelDreDistrito(id);
      }
    },

    //--------------editar colegio--------------
    async getColegio() {
      try {
        let response = await axios.get(
          "/administrativo/colegio/" + this.datoLogin.id_colegio
        );
        this.editedItem = await response.data;
        // console.log(this.editedItem);

        await this.getUbicacion1Id(this.editedItem.id_pais);
        await this.getUbicacion2Id(this.editedItem.id_ubicacion1);
        await this.getUbicacion3Id(this.editedItem.id_ubicacion2);

        await this.getUgelDreDistrito(response.data.id_ubicacion3);
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        //console.log(error);
      }
    },

    async saveItem() {
      let params = { colegio: this.editedItem };
      if (this.$refs.formMiColegio.validate()) {
        try {
          let response = await axios.put(
            `/manager/colegio/miColegio/${this.editedItem.id}`,
            params
          );
          console.log('datos',response);

          this.setEnviarMens({
            tipo: "S",
            mensaje: "¡Información editada con éxito!",
            tiempo: null,
          });

          //Si existe Imagen previa y la el logo proceder a Guardar
          if (this.imageSaveLogo) {
            this.saveLogo()
          }
        } catch (error) {
          this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        }
      }
    },

    
    //////////////////////////////////
    ///    SUBIR LOGO COLEGIO      ///
    //////////////////////////////////
    
    // guardar imagen del colegio
    saveLogo() {
      let formData = new FormData();

      formData.append("subirArchivo", this.imageSaveLogo);
      formData.append("id_colegio", this.editedItem.id);
      formData.append("id_usuario", this.datoLogin.id);

      axios.post("archivo/logoColegio", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then((res) => {
          console.log(res);
          this.setEnviarMens({
            tipo: "W",
            mensaje: `Su imagen será visualizada al iniciar sesión`,
            tiempo: null,
          });
        })
        .catch(function (e) {
          console.log(e);
          this.setEnviarMens({
            tipo: "E",
            mensaje: `Error en Subir Imagen`,
            tiempo: null,
          });
        });
    },

    pickLogo() {
      // activar imput tipo file
      this.$refs.imageCol.click();
    },

    // Seleccion del archivo por el usuario
    onFileLogo(e) {
      const files = e.target.files || e.dataTransfer.files;

      if (!files.length) return;
      // crea imagen temporar para visualizar
      this.createImageLogo(files[0]);

      if (files[0] !== undefined) {
        this.imageSaveLogo = files[0]; // this is an image file that can be sent to server...
      }
    },

    // funcion para crear una imagen temporal
    createImageLogo(file) {
      var image = new Image();
      console.log(image);
      var reader = new FileReader();
      // var vm = this;
      reader.onload = (e) => {
        this.previewImgLogo = e.target.result;
      };
      reader.readAsDataURL(file);
    },

    async getUbicacion1Id(id) {
      this.ubicacion2 = [];
      this.ubicacion3 = [];
      this.editedItem.ubicacion2 = null;
      this.editedItem.ubicacion3 = null;
      try {
        let response = await axios.get("/mantenimiento/ubicacion1/" + id);
        this.ubicacion1 = response.data;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        //console.log(error);
      }
    },

    async getUbicacion2Id(id) {
      this.ubicacion3 = [];
      this.editedItem.ubicacion3 = null;
      this.clear_dre_ugel();
      try {
        let response = await axios.get("/mantenimiento/ubicacion2/" + id);
        this.ubicacion2 = response.data;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        //console.log(error);
      }
    },

    async getUbicacion3Id(id) {
      try {
        let response = await axios.get("/mantenimiento/ubicacion3/" + id);
        this.ubicacion3 = response.data;
        this.clear_dre_ugel();
        this.getUgelDreProvince(id);
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        //console.log(error);
      }
    },

    validar_direccion($event) {
      //this.editedItem.direc_colegio =
      this.$options.filters.address($event);
    },
  },
};
</script>

<style scoped>
.fondo_add_img {
  cursor: pointer;
  cursor: hand;
  max-width: 100%; /* Esto asegura que la imagen no sea más ancha que su contenedor */
  max-height: 100%; /* Esto asegura que la imagen no sea más alta que su contenedor */
  height: auto; /* Esto mantiene la proporción original de la imagen */

}

.avatar_fondo_add_img{
  border-radius: 10%; 
  border: solid 1px rgb(197, 197, 197);
  border-style: dashed;
}

</style>
